/* unplugin-vue-components disabled */import { render } from "./occupation.vue?vue&type=template&id=6f97cebc"
import script from "./occupation.vue?vue&type=script&lang=js"
export * from "./occupation.vue?vue&type=script&lang=js"

import "./occupation.vue?vue&type=style&index=0&id=6f97cebc&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿英文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__